import { useRouter } from 'next/navigation';
import React from 'react';

interface ErrorMessageProps {
  title?: string;
  message: string;
  showBackButton?: boolean;
  backButtonText?: string;
  backButtonPath?: string;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = 'Error',
  message,
  showBackButton = true,
  backButtonText = 'Return to Login',
  backButtonPath = '/login',
  className = '',
}) => {
  const router = useRouter();

  return (
    <div className={`min-h-screen flex items-center justify-center ${className}`}>
      <div className="w-full max-w-md">
        <div className="bg-white p-8 shadow-md rounded-lg text-center">
          <div className="flex items-center justify-center w-12 h-12 mx-auto text-red-500">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="mt-4 text-xl font-semibold text-red-600">{title}</h2>
          <p className="mt-2 text-gray-600">{message}</p>
          {showBackButton && (
            <button 
              className="mt-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700"
              onClick={() => router.push(backButtonPath)}
            >
              {backButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage; 